import { States } from 'safe'
import {
  SET_CLIENTS,
  SET_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  ClientTypes,
  ENABLE_CLIENT,
  UPDATE_CREDIT,
  DELETE_DOCUMENT_CLIENT,
  ADD_DOCUMENT_CLIENT,
} from '../actions/actionTypes'

const initialState: States.Client = {
  clients: [],
  numberOfPages: 0,
}

//eslint-disable-next-line
export default (state = initialState, action: ClientTypes): States.Client => {
  let _clients, index
  switch (action.type) {
    case SET_CLIENTS:
      return {
        ...state,
        clients: action.payload.clients,
        numberOfPages: action.payload.numberOfPages,
      }

    case SET_CLIENT:
      return { ...state, clients: [...state.clients, action.payload] }

    case UPDATE_CLIENT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.id)
      _clients[index] = { ..._clients[index], ...action.payload }
      return { ...state, clients: _clients }

    case DELETE_CLIENT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.id)
      _clients.splice(index, 1)
      return { ...state, clients: _clients }

    case ENABLE_CLIENT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.id)
      _clients[index] = {
        ..._clients[index],
        enable: action.payload.enable,
      }
      return { ...state, clients: _clients }
    case UPDATE_CREDIT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.id)
      _clients[index] = {
        ..._clients[index],
        credit: action.payload.credit,
      }
      return { ...state, clients: _clients }
    case DELETE_DOCUMENT_CLIENT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.clientId)
      _clients[index].documents = _clients[index].documents.filter(
        (document) => document.id !== action.payload.id
      )
      return { ...state, clients: _clients }
    case ADD_DOCUMENT_CLIENT:
      _clients = [...state.clients]
      index = _clients.findIndex((i) => i.id === action.payload.clientId)
      _clients[index].documents.push({
        id: action.payload.document.id,
        provider: action.payload.clientId,
        url: action.payload.document.url,
      })
      return { ...state, clients: _clients }
    default:
      return state
  }
}